// 一覧下部のページング部分の共通コンポーネントをまとめたファイル

import { scrollContentsToTop } from '../../utils/scroll';

/**
 * ページ番号の一つ一つの要素
 * @param
 * @returns
 */
function PageLink({ page, isCurrent, onChangePage }: { page: number; isCurrent: boolean; onChangePage: () => void }) {
  if (isCurrent) {
    return (
      <li className="current">
        <span>{page}</span>
      </li>
    );
  }

  return (
    <li>
      <a
        href="."
        onClick={(e) => {
          e.preventDefault();
          onChangePage();
        }}
      >
        {page}
      </a>
    </li>
  );
}

interface Props {
  current: number;
  pageCount: number;
  onChangePage: (page: number) => void;
}

/**
 * ページング部分のコンポーネント
 * @param
 * @returns
 */
function PageNavi({ current, pageCount, onChangePage }: Props) {
  // ページ番号の最小値 現在のページ - 2 か 現在のページ - 4 か 1
  const min = Math.max(Math.min(current - 2, pageCount - 4), 1);

  // ページ番号の最大値 現在のページ + 2 か 5 か 現在のページ
  const max = Math.min(Math.max(current + 2, 5), pageCount);

  return (
    <div className="pagenavi">
      <ul>
        {/* < ボタン */}
        <li className="pre">
          <button
            type="button"
            className="text-button"
            onClick={() => {
              onChangePage(Math.max(current - 1, 1));
              scrollContentsToTop();
            }}
          >
            <i className="fa-solid fa-chevron-left" />
          </button>
        </li>
        {/* ページ番号ボタン */}
        {Array.from({ length: max - min + 1 }, (_, i) => min + i).map((x) => (
          <PageLink
            key={x}
            page={x}
            isCurrent={x === current}
            onChangePage={() => {
              onChangePage(x);
              scrollContentsToTop();
            }}
          />
        ))}
        {/* > ボタン */}
        <li className="next">
          <button
            type="button"
            className="text-button"
            onClick={() => {
              onChangePage(Math.min(current + 1, pageCount));
              scrollContentsToTop();
            }}
          >
            <i className="fa-solid fa-chevron-right" />
          </button>
        </li>
      </ul>
    </div>
  );
}

export default PageNavi;
